import theme from '@gaia/theme';

import AppButtons from './AppButtons';

export default function GLError() {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                flexDirection: 'column',
            }}
        >
            <strong
                style={{
                    color: theme.palette.error.main,
                    marginBottom: theme.spacing(1),
                }}
            >
                Sorry! Your computer cannot display this map.
            </strong>
            <div style={{marginBottom: theme.spacing(2)}}>
                Please try downloading the Gaia GPS mobile app.
            </div>
            <AppButtons analyticsContext='topbar' />
        </div>
    );
}
